import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";
const MWhHistory: { value: string; startDate: string; endDate: string }[] = [
  {
    value: " 60,23",
    startDate: "05/03/2021",
    endDate: "Atual",
  },
  {
    value: " 56,23",
    startDate: "04/02/2021",
    endDate: "04/03/2021",
  },
  {
    value: " 51,23",
    startDate: "29/01/2021",
    endDate: "03/02/2021",
  },
  {
    value: "45,23",
    startDate: "13/01/2021",
    endDate: "28/01/2021",
  },
  {
    value: "34,76",
    startDate: "01/01/2021",
    endDate: "12/01/2021",
  },
];
export default function MWhHistoryTable() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography sx={{ fontWeight: "bold", marginBottom: "10px" }}>
        Histórico de Valores do MWh
      </Typography>
      <Paper sx={{ width: 400, overflow: "hidden", height: "90%" }}>
        <TableContainer sx={{ maxHeight: 200 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center">Valor</TableCell>
                <TableCell align="center">Data Início</TableCell>
                <TableCell align="center">Data Fim</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {MWhHistory.map((register, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell align="center">R$ {register.value}</TableCell>
                    <TableCell align="center">{register.startDate}</TableCell>
                    <TableCell align="center">{register.endDate}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
